import { useEffect, useRef } from 'react';

const useWebSocket = (protocols) => {
  const webSocketRef = useRef(null);
  const retryTimeoutRef = useRef(null);

  const protocol = 'wss';
  const host = window.location.hostname;
  const isProd = process.env.NODE_ENV === 'production';
  const port = isProd ? '' : '3001';
  const wsUrl = isProd ? `${protocol}://${host}/api/frontend` : `${protocol}://${host}:${port}/api/frontend`;

  const connect = () => {
    const ws = new WebSocket(wsUrl, protocols);
    webSocketRef.current = ws;

    ws.onopen = () => {
      console.log('WebSocket connection opened');
    };

    ws.onmessage = (message) => {
      console.log('WebSocket message received:', message.data);
    };

    ws.onclose = () => {
      console.log('WebSocket connection closed');
      scheduleReconnect();
    };

    ws.onerror = (error) => {
      console.error('WebSocket error:', error);
      scheduleReconnect();
    };
  };

  const scheduleReconnect = () => {
    if (retryTimeoutRef.current) {
      clearTimeout(retryTimeoutRef.current);
    }
    retryTimeoutRef.current = setTimeout(connect, 5000); // Retry every 5 seconds
  };

  useEffect(() => {
    connect();

    return () => {
      if (webSocketRef.current) {
        webSocketRef.current.close();
      }
      if (retryTimeoutRef.current) {
        clearTimeout(retryTimeoutRef.current);
      }
    };
  }, [protocols]);

  return webSocketRef.current;
};

export default useWebSocket;
